module.exports = __webpack_public_path__ + "static/media/scheduler_text_catalog.7f1e0454.xlsx";